import React, { useState } from "react";
import { ActionType } from "../../models/Enums";
import { useRecoilState } from "recoil";
import {
	newAllDropDownState,
	PatientState,
	dummyDropDowns,
	isDuplicateCalledState,
} from "../../data/atoms";
import { PatientVM } from "../../models/PatientVM";
import { useHistory } from "react-router";
import ProactiveYouModal from "./ProactiveYouModal";
import { IonModal, IonPage } from "@ionic/react";

interface Props {
	setShowModal: Function;
	showProactiveModal?: any;
	actionType: number;
}

const SuccessModal: React.FC<Props> = ({
	setShowModal,
	actionType,
	showProactiveModal,
}) => {
	let history = useHistory();
	const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
		isDuplicateCalledState
	);

	async function GetPatientDetails() {
		setIsDuplicateCalled(false);
		setShowModal(false);
		window.location.href = window.location.origin + "/patient-page";
		// history.replace("/patient-page");
	}

	return (
		<>
			<IonPage placeholder={undefined}>
				<div className="all-generic-new-modal-center new-success-modal-wrap w-468-for-modal">
					<div className="new-success-modalinner-wrap">
						{actionType != ActionType.LoadSaving &&
							actionType != ActionType.LoadSending &&
							actionType != ActionType.LoadPrinting &&
							actionType != ActionType.SuccessExercisePlanSent &&
							actionType != ActionType.SuccessExercisePlanSaved &&
							actionType != ActionType.SuccessPrintExercisePlan &&
							actionType != ActionType.ErrorPrintExercisePlan && (
								<svg
									width="25"
									height="25"
									viewBox="0 0 25 25"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									className="close-icon"
									onClick={() => {
										setShowModal(false);
									}}>
									<path
										d="M21.8397 21.4798L3.11084 2.8457M21.8399 2.8457L3.11084 21.4799"
										stroke="#D1D1D1"
										strokeWidth="5.17618"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							)}
						{actionType != ActionType.LoadSaving &&
							actionType != ActionType.LoadSending &&
							actionType != ActionType.LoadPrinting &&
							actionType != ActionType.ErrorPrintExercisePlan &&
							actionType != ActionType.ErrorEditPatient && (
								<svg
									width="145"
									height="146"
									viewBox="0 0 145 146"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M72.5 138C108.399 138 137.5 108.899 137.5 73C137.5 37.1015 108.399 8 72.5 8C36.6015 8 7.5 37.1015 7.5 73C7.5 108.899 36.6015 138 72.5 138Z"
										fill="#0F854C"
										stroke="#0F854C"
										strokeWidth="14.4444"
										strokeMiterlimit="10"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M94.1668 58.5557L65.2779 87.4446L50.8335 73.0001"
										stroke="white"
										strokeWidth="14.4444"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							)}

						{actionType == ActionType.ErrorPrintExercisePlan && (
							<svg
								width="145"
								height="146"
								viewBox="0 0 145 146"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M0.277832 73.0005C0.277832 33.1133 32.6128 0.77832 72.5001 0.77832C112.387 0.77832 144.722 33.1133 144.722 73.0005C144.722 112.888 112.387 145.223 72.5001 145.223C32.6128 145.223 0.277832 112.888 0.277832 73.0005ZM55.9403 46.227C53.1198 43.4065 48.547 43.4065 45.7265 46.227C42.9061 49.0474 42.9061 53.6203 45.7265 56.4408L62.2862 73.0005L45.7265 89.5602C42.9061 92.3806 42.9061 96.9535 45.7265 99.7739C48.547 102.594 53.1198 102.594 55.9403 99.7739L72.5 83.2142L89.0594 99.7737C91.8799 102.594 96.4527 102.594 99.2732 99.7737C102.094 96.9532 102.094 92.3804 99.2732 89.5599L82.7137 73.0005L99.2734 56.4408C102.094 53.6203 102.094 49.0474 99.2734 46.227C96.453 43.4065 91.8801 43.4065 89.0597 46.227L72.5 62.7867L55.9403 46.227Z"
									fill="#890029"
								/>
							</svg>
						)}

						{actionType == ActionType.ErrorEditPatient && (
							<svg
								width="62"
								height="61"
								viewBox="0 0 62 61"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M39.125 0.549988L36.5625 23.55L59.875 17.05L61.9375 32.8L40.6875 34.3L54.625 52.8625L40.4375 60.425L30.6875 40.8625L22.125 60.3L7.375 52.8625L21.1875 34.3L0.0625 32.675L2.5 17.05L25.3125 23.55L22.75 0.549988H39.125Z"
									fill="#802392"
								/>
							</svg>
						)}

						{actionType == ActionType.SuccessUpdateUserProfile && (
							<h1>Success</h1>
						)}

						{actionType === ActionType.LoadSending ||
						actionType === ActionType.LoadSaving ||
						actionType === ActionType.LoadPrinting ? (
							<div className="spinner"></div>
						) : undefined}

						{actionType == ActionType.ErrorEditPatient && <h1>Error</h1>}

						{actionType == ActionType.LoadSending && <h1>Sending...</h1>}

						{actionType == ActionType.LoadSaving && <h1>Saving...</h1>}

						{actionType == ActionType.LoadPrinting && <h1>Printing...</h1>}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessUpdateUserProfile && (
								<p>Your password has been updated.</p>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessExercisePlanSent && (
								<h1>Exercise plan has been sent!</h1>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessExercisePlanSaved && (
								<h1>Exercise plan has been saved!</h1>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessPrintExercisePlan && (
								<h1>Exercise plan has been printed!</h1>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.ErrorPrintExercisePlan && (
								<h1>Exercise plan has not been printed!</h1>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.ErrorEditPatient && (
								<p>Required field left incomplete.</p>
							)}

						{(actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessUpdateUserProfile) ||
							(actionType == ActionType.ErrorPrintExercisePlan && (
								<>
									<button
										className="blue-outline-btn mb-12"
										onClick={() => {
											setShowModal(false);
										}}>
										Go Back
									</button>
									<button
										className="ancher-generic-btn "
										onClick={() => {
											setShowModal(false);
											GetPatientDetails();
										}}>
										Exit without Saving
									</button>
								</>
							))}
						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.ErrorEditPatient && (
								<>
									<button
										className="ancher-generic-btn mb-12"
										onClick={() => {
											setShowModal(false);
										}}>
										Go Back
									</button>
									<button
										className="blue-outline-btn"
										onClick={() => {
											setShowModal(true);
										}}>
										Exit without Saving
									</button>
								</>
							)}

						{actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessExercisePlanSent && (
								<button
									className="blue-outline-btn"
									onClick={() => {
										setShowModal(false);
										showProactiveModal(true);
									}}>
									Download ProactiveYou
								</button>
							)}

						{(actionType != ActionType.LoadPrinting &&
							actionType == ActionType.SuccessExercisePlanSent) ||
						actionType == ActionType.SuccessExercisePlanSaved ||
						actionType == ActionType.SuccessPrintExercisePlan ? (
							<button
								className="ancher-generic-btn mb-12"
								onClick={GetPatientDetails}>
								Back to Patient Home
							</button>
						) : (
							<></>
						)}
					</div>
				</div>
			</IonPage>
		</>
	);
};

export default SuccessModal;
